import { FC } from "react";
import { AllieRadioProps } from "./Radio.types";
import { AllieCheckbox } from "../../Checkbox";
import { AllieItem } from "../../Item/Item";
import { AllieLabel } from "../../Item/Label";

export const AllieRadio: FC<AllieRadioProps> = ({
  value,
  onChange,
  options,
  ...props
}) => {
  // useEffect(() => {
  //   let checkboxEl = document.querySelector('ion-checkbox.checkbox-checked');
  //   console.log('checkboxEl', checkboxEl);
  //   checkboxEl?.classList.remove('checkbox-disabled');
  //   let itemEl = document.querySelector('ion-item.item-checkbox-checked');
  //   itemEl?.classList.remove('item-interactive-disabled');
  // }, [value]);

  return (
  <>
    {
      options.map(({ value: optValue, label, labelPlacement = 'start' }) => (
        <AllieItem key={optValue}>
          {
            labelPlacement === 'start' && (
              <AllieLabel style={{ paddingRight: 10 }}>{label}</AllieLabel>
            )
          }
          <AllieCheckbox
            className="ion-active"
            value={optValue}
            checked={optValue === value}
            disabled={optValue === value}
            onIonChange={(e: any) => { if (e.detail.checked) onChange(e) }}
            mode="ios"
            {...props}
          />
          {
            labelPlacement === 'end' && (
              <AllieLabel style={{ paddingLeft: 10 }}>{label}</AllieLabel>
            )
          }
        </AllieItem>
      ))
    }
  </>
)};
